<div *ngIf="is_open" class="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
    <div class="bg-white w-[459px] rounded-[16px] shadow-[0px_2px_6px_2px_rgba(0,0,0,0.15),0px_1px_2px_0px_rgba(0,0,0,0.3)]  px-[32px] py-[24px] flex flex-col gap-[24px]">
        <div class="flex flex-col gap-[8px] text-center">
            <h2 class="text-start font-medium text-[20px] leading-[100%] tracking-[0.02em] text-[#212121]">{{title}} </h2>
            <p class="text-start font-normal text-[14px] leading-[100%] tracking-[0.02em] text-[#616161] mt-2"> {{description}}</p>
        </div>
        <div class="flex justify-center gap-[28px]">
            <button (click)="close()" class="w-[180px] h-[48px] rounded-full border border-[#D1D5DB]  text-[#374151] font-medium hover:bg-gray-100 transition"> {{cancelText}}</button>
            <button (click)="confirm()" class="w-[180px] h-[48px] rounded-full bg-[#3F41D1]  text-white font-medium hover:bg-indigo-700 transition"> {{confirmText}}</button>
        </div>
    </div>
</div>